const RegexPatterns = {
  address: /^(\d*[\wäöüß\d '\/\\\-\.]+)[,\s]+(\d+)\s*([\wäöüß\d\-\/]*)$/i,
  numbersOnly: /\D/g,
  kvkNumber: /^\d{8}$/g,
  kvkLocationNumber: /^\d{12}$/g,
  phoneNumber:
    /(?:0|(?:\+|00) ?31 ?)(?:(?:[1-9] ?(?:[0-9] ?){8})|(?:6 ?-? ?[1-9] ?(?:[0-9] ?){7})|(?:[1,2,3,4,5,7,8,9]\d ?-? ?[1-9] ?(?:[0-9] ?){6})|(?:[1,2,3,4,5,7,8,9]\d{2} ?-? ?[1-9] ?(?:[0-9] ?){5}))/,
  zipcode: /[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}/gi,
  houseNumber: /[1-9]\d{0,3}[a-z]?/i,
  zipcodeHouseNumber: /(?<zipcode>[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}) (?<houseNumber>\d*)/i,
  email: /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/g,
  poId: /[1-9]\d{4,9}/,
  // License plate is 6 characters long, at least 1 number and at least 2 letters (case-insensitive)
  licensePlate: /^(?=.*\d)(?=.*[a-z]{2,})[a-z0-9]{6}$/i,
  whitespaceDashes: /[\s|-]*/g,
}

export default {
  parseAddress(fullAddress) {
    const match = fullAddress?.match(RegexPatterns.address)

    if (match) {
      return {
        street: match[1] || '',
        houseNumber: match[2] || '',
        houseNumberAddition: match[3] || '',
      }
    }
    return {
      street: '',
      houseNumber: '',
      houseNumberAddition: '',
    }
  },
  parsePostcodeNumbers(postcode) {
    return parseInt(postcode.replace(RegexPatterns.numbersOnly, ''))
  },
  filterRegex(regex, value) {
    if (regex.test(value)) {
      return value.match(regex)[0]
    }
    return null
  },
  filterPoIdOrKvkNumber(value) {
    let kvkNumber = this.filterKvkNumber(value)
    if (!!kvkNumber) {
      return kvkNumber
    }

    return this.filterPoId(value)
  },
  filterKvkNumber(value) {
    return this.filterRegex(RegexPatterns.kvkNumber, value)
  },
  filterKvkLocationNumber(value) {
    return this.filterRegex(RegexPatterns.kvkLocationNumber, value)
  },
  filterPhoneNumber(value) {
    return this.filterRegex(RegexPatterns.phoneNumber, value)
  },
  filterZipcodeHouseNumber(value) {
    const regEx = RegexPatterns.zipcodeHouseNumber
    if (regEx.test(value)) {
      return value.match(regEx).groups
    }
    return null
  },
  filterZipcode(value) {
    return this.filterRegex(RegexPatterns.zipcode, value)?.replace(' ', '')
  },
  filterPoId(value) {
    return this.filterRegex(RegexPatterns.poId, value)
  },
  filterHouseNumber(value) {
    let valueWithoutPhonenumberAndZipcode = value

    valueWithoutPhonenumberAndZipcode = valueWithoutPhonenumberAndZipcode.replace(
      this.filterPhoneNumber(valueWithoutPhonenumberAndZipcode),
      ''
    )
    valueWithoutPhonenumberAndZipcode = valueWithoutPhonenumberAndZipcode.replace(
      this.filterZipcode(valueWithoutPhonenumberAndZipcode),
      ''
    )

    return this.filterRegex(RegexPatterns.houseNumber, valueWithoutPhonenumberAndZipcode)
  },
  filterEmail(value) {
    return this.filterRegex(RegexPatterns.email, value)
  },
  filterLicensePlate(value) {
    const regex = RegexPatterns.licensePlate
    const strippedValue = value.replace(RegexPatterns.whitespaceDashes, '')
    if (regex.test(strippedValue) && (!this.filterZipcode(strippedValue) || value.includes('-'))) {
      return strippedValue.match(regex)[0]
    }
    return null
  },
  CompanyToCustomerExtend(company) {
    if (!company) return {}

    company.CustomerZipCode = company.CustomerCompanyZipcode
    company.CustomerCity = company.CustomerCompanyCity
    company.CustomerPhone = company.CustomerCompanyPhoneNumber
    company.CustomerEmail = company.CustomerCompanyEmailAddress
    company.CustomerMagicNumber = company.CustomerCompanyMagicNumber
    company.CustomerAddress = company.CustomerCompanyAddress

    return company
  },
}
